const siteServiceSecurityServiceName = "/TimesheetSiteServiceSecurity";

export function manipulationService (http) {
    return {
        saveSiteServiceSecurityTimesheetAsync: async(activityCode,activityDiscipline, costCenterCode,siteServiceSecurityTypeId, gregorianDateTime, jalaliDate,currentUser, userName, processType, personnelInformationList) => {
            let params = {
                personnelInformationList,
                processType,
                siteServiceSecurityTypeId,
                userName,
                activityCode,
                activityDiscipline,
                costCenterCode,
                jalaliDate,
                gregorianDateTime,
                currentUser
            }
            return await http.post(siteServiceSecurityServiceName + "/SaveSiteServiceSecurityTimesheetAsync", params);
        },
        saveSiteTimesheetAsync: async(activityCode,activityDiscipline, costCenterCode,siteServiceSecurityTypeId, gregorianDateTime, jalaliDate,gregorianDateTimeTo, jalaliDateTo,currentUser, userName, processType, personnelInformation) => {
            let params = {
                personnelInformation,
                processType,
                siteServiceSecurityTypeId,
                userName,
                activityCode,
                activityDiscipline,
                costCenterCode,
                jalaliDate,
                gregorianDateTime,
                jalaliDateTo,
                gregorianDateTimeTo,
                currentUser
            }
            return await http.post(siteServiceSecurityServiceName + "/SaveSiteTimesheetAsync", params);
        },        
        deleteSiteServiceSecurityTimesheetAsync: async(personnelCode, costCenterCode,activityCode,activityDiscipline, fromDate, toDate) => {
            let params = {
                personnelCode, 
                costCenterCode,
                activityCode,
                activityDiscipline, 
                fromDate, 
                toDate            
            }
            return await http.post(siteServiceSecurityServiceName + "/BatchDeleteTimesheetAsync", params);
        },
        deleteSiteTimesheetAsync: async(personnelCode, costCenterCode, gregorianFromDate, gregorianToDate) => {
            let params = {
                personnelCode,
                costCenterCode,
                fromDate: gregorianFromDate,
                toDate: gregorianToDate
            }
            return await http.post(siteServiceSecurityServiceName + "/DeleteSiteTimesheetAsync", params);
        },
        deleteTimesheetAsync: async(personnelCode, costCenterCode, gregorianFromDate, gregorianToDate) => {
            let params = {
                personnelCode,
                costCenterCode,
                fromDate: gregorianFromDate,
                toDate: gregorianToDate
            }
            return await http.post(siteServiceSecurityServiceName + "/DeleteTimesheetAsync", params);
        }
    }
}